import { ShowroomNavigationManagerV1Impl } from "./v1";
export const defineShowroomNavigationManager = (options) => {
    const { extension, navigationConfig, replaceOnSync, noSuffix } = options;
    return {
        id: "showroom-navigation",
        dependencies: {
            featureServices: {
                "car-configuration": "^1.0.0",
                "s2:history": "^3.0.0"
            }
        },
        create(env) {
            const carConfigurationService = env.featureServices["car-configuration"];
            const historyService = env.featureServices["s2:history"];
            const showroomNavigationManagerV1 = new ShowroomNavigationManagerV1Impl(navigationConfig, carConfigurationService, historyService, extension, replaceOnSync, noSuffix);
            return {
                "1.0.0": () => ({ featureService: showroomNavigationManagerV1 }),
                "1.1.0": () => ({ featureService: showroomNavigationManagerV1 })
            };
        }
    };
};
